import "@/polyfills/reportValidity";
import "core-js/actual/object/has-own";
import "core-js/actual/structured-clone";
import "form-request-submit-polyfill";

import App from "@/App.vue";
import router from "@/router";
import Vue from "vue";
//import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import store from "@/store/store";
import axios from "axios";
import VueSweetalert2 from "vue-sweetalert2";

import "sweetalert2/dist/sweetalert2.min.css";
//import "./registerServiceWorker";
import api from "@/services/vex/api";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import Inputmask from "inputmask";
import PortalVue from "portal-vue";
import "vue-material/dist/theme/default.css";
import "vue-material/dist/vue-material.min.css";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-bootstrap.css";
import apiCarga from "./services/vex/apiCarga";

const VueInputMask = {
    install: function(Vue, options) {
        Vue.directive("mask", {
            bind: function(el, binding) {
                Inputmask(binding.value).mask(el);
            }
        });
    }
};


//Vue.use(BootstrapVue);
//Vue.use(IconsPlugin);
Vue.use(VueSweetalert2);
Vue.use(PortalVue);
Vue.use(VueToast);
Vue.use(VueInputMask);

Vue.config.productionTip = false;

Vue.prototype.$http = axios;
Vue.prototype.$api = api;
Vue.prototype.$apiCarga = apiCarga;

axios.defaults.baseURL = import.meta.env.VITE_USE_ROOT_API;

Vue.directive("uppercase", {
    inserted: function (el, _, vnode) {
        el.addEventListener("input", async function (e) {
            e.target.value = e.target.value.toUpperCase();
            vnode.componentInstance.$emit("input", e.target.value.toUpperCase());
        });
    },
});

export default new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
